import Styles from './NewsCard.scss';

import Template from './NewsCard.hbs';
import NewsMessage from './newsMessage/NewsMessage'

export default class NewsCard extends BaseView {
    get events() {
        return {
            click: 'onClickNews',
            'click .js-hide': 'onClickHideNews',
        }
    }

    initialize() {
        this.setElement(Template({
            Styles,
            title: this.model.get('title'),
            actionText: this.model.get('action_text'),
            headerImage: this.model.get('header_image_url'),
            canHide: !Backbone.Model.user.get('is_demo')
        }))
    }

    onClickNews() {
        Backbone.View.sidebar.showSidebar(
            new NewsMessage({
                model: this.model
            }),
            window.i18n.gettext('News'),
            520
        )
    }

    onClickHideNews(event) {
        event.stopPropagation()
        $.post({
            url: '/users/set_news_to_closed/' + this.model.id + '.json'
        })
        Tracking.trackEvent(
            'News',
            'Hide message',
            this.model.id
        )
        this.destroy()
    }
}
